/**
 * @generated SignedSource<<dd5c4801ca37851e26fe3fb29765d1b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeUninstall_viewer$data = {
  readonly id: string;
  readonly user: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"LoginBtn_viewer">;
  readonly " $fragmentType": "HomeUninstall_viewer";
};
export type HomeUninstall_viewer$key = {
  readonly " $data"?: HomeUninstall_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeUninstall_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeUninstall_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LoginBtn_viewer"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "fe36795e544fba634a6594db2c7f6aad";

export default node;
